import type { Signal } from '@angular/core';

// Light injection tokens: each abstract class is both the DI token and the type contract, so the
// trigger and the group reach each other without either importing the other's implementation.

export abstract class SbDisclosureFlyoutTrigger {
  /** Shuts this one because a sibling in the same group took its place. */
  abstract collapse(): void;
}

export abstract class SbDisclosureFlyoutGroup {
  /**
   * The one trigger currently expanded, if any. A trigger reads it to tell a first open from a
   * swap, which get different hover delays.
   */
  abstract expandedTrigger: Signal<SbDisclosureFlyoutTrigger | undefined>;

  /** Takes the group's single expanded slot, collapsing whoever held it. */
  abstract claimExpanded(trigger: SbDisclosureFlyoutTrigger): void;

  /** Gives the slot back, if this trigger still holds it. */
  abstract releaseExpanded(trigger: SbDisclosureFlyoutTrigger): void;
}
